// Import firebase services
import { firebaseAuth, configModel } from '@/firebase/firebase-config'

// Import the mixins
import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'

export const ConfigRepository = {

	/*
	**  Register the mixins
	*/

	mixins: [

		BugsnagService

	],

	/*
	**  Set up the methods
	*/

	methods: {

		getStates: function() {

			// Get the options
			configModel.doc('states').get()
			.then(doc => {

				if (!doc.exists) return;

				// Set the prop
				this.states = doc.data();

			})
			.catch(error => {
				
				// Send to bugsnag
				this.reportAuthBugsnagError({
					title: 'Get States Config',
					errorType: 'Firestore Database',
					section: 'Repositories',
					component: 'ConfigRepository',
					error: error
				});

			});

		},

		getUnitTypes: function() {

			// Get the options
			configModel.doc('unit_options').get()
			.then(doc => {

				if (!doc.exists) return;

				// Set the prop
				this.unit_types = doc.data();

			})
			.catch(error => {
				
				// Send to bugsnag
				this.reportAuthBugsnagError({
					title: 'Get Unit Options Config',
					errorType: 'Firestore Database',
					section: 'Repositories',
					component: 'ConfigRepository',
					error: error
				});

			});

		},

		getCompanyTypes: function() {

			// Get the options
			configModel.doc('company_options').get()
			.then(doc => {

				if (!doc.exists) return;

				// Set the prop
				this.company_options = doc.data();

			})
			.catch(error => {
				
				// Send to bugsnag
				this.reportAuthBugsnagError({
					title: 'Get Company Options Config',
					errorType: 'Firestore Database',
					section: 'Repositories',
					component: 'ConfigRepository',
					error: error
				});

			});

		},

		getLeaseOptions: function() {

			// Get the options
			configModel.doc('lease_options').get()
			.then(doc => {

				if (!doc.exists) return;

				// Set the prop
				this.lease_options = doc.data();

			})
			.catch(error => {
				
				// Send to bugsnag
				this.reportAuthBugsnagError({
					title: 'Get Lease Options Config',
					errorType: 'Firestore Database',
					section: 'Repositories',
					component: 'ConfigRepository',
					error: error
				});

			});

		},

		getRentOptions: function() {

			// Get the options
			configModel.doc('rent_options').get()
			.then(doc => {

				if (!doc.exists) return;

				// Set the prop
				this.rent_options = doc.data();

			})
			.catch(error => {
				
				// Send to bugsnag
				this.reportAuthBugsnagError({
					title: 'Get Rent Options Config',
					errorType: 'Firestore Database',
					section: 'Repositories',
					component: 'ConfigRepository',
					error: error
				});

			});

		},

		getPropertyTypes: function() {

			// Get the options
			configModel.doc('property_types').get()
			.then(doc => {

				if (!doc.exists) return;

				// Set the prop
				this.property_types = doc.data();

			})
			.catch(error => {
				
				// Send to bugsnag
				this.reportAuthBugsnagError({
					title: 'Get Property Types Config',
					errorType: 'Firestore Database',
					section: 'Repositories',
					component: 'ConfigRepository',
					error: error
				});

			});

		},

		getNextSteps: function() {

			// Get the options
			configModel.doc('next_steps').get()
			.then(doc => {

				if (!doc.exists) return;

				// Set the prop
				this.next_steps = doc.data();

			})
			.catch(error => {
				
				// Send to bugsnag
				this.reportAuthBugsnagError({
					title: 'Get Next Steps Config',
					errorType: 'Firestore Database',
					section: 'Repositories',
					component: 'ConfigRepository',
					error: error
				});

			});

		}

	},

}